import mutations from './mutations'
import actions from "./actions";
const menu = {
    namespaced: true,
    state: {
        menus: []
    },
    mutations,
    actions
}
export default menu